import { ScoringFixtureGame } from 'app-types';

export const parseScoring = (response: Record<string, ScoringFixtureGame>) => {
  return {
    games: parseGames(response),
  };
};

const parseGames = (games: Record<string, ScoringFixtureGame>) => {
  const result: Array<{
    statusDesc: string;
    id: string;
    awayTeam: { id: string; name: string; nickName: string; score: string };
    homeTeam: { id: string; name: string; nickName: string; score: string };
    scheduledTime: string;
    leagueId: string;
    leagueName: string;
    typeDetail: string;
  }> = [];
  Object.keys(games).forEach(id => {
    const data = games[id];
    const parsed = {
      statusDesc: data.gameStatusDesc,
      id: data.gameId,
      awayTeam: {
        id: data.awayTeamId,
        name: data.awayTeam.mediumName,
        nickName: data.awayTeam.nickName,
        score: data.awayTeamScore,
      },
      homeTeam: {
        id: data.homeTeamId,
        name: data.homeTeam.mediumName,
        nickName: data.homeTeam.nickName,
        score: data.homeTeamScore,
      },
      scheduledTime: data.scheduledTime,
      leagueId: data.leagueId,
      leagueName: data.leagueName,
      typeDetail: data.gameTypeDetail,
    };
    result.push(parsed);
  });

  return result;
};
